import { Component, Prop } from 'vue-property-decorator';
import InputMixin from '@/mixins/inputMixins/base/InputMixin';

@Component
export default class ObjectInputMixin extends InputMixin {
  @Prop({ default: undefined }) defaultValue: object | undefined;
  @Prop({ default: false }) hasChild: boolean;
}
